import React from "react"
import { BodyTextRegular } from "../typography/text"
import { Link, useI18next } from "gatsby-plugin-react-i18next"

type Props = {
  href: string
  children: React.ReactNode
  internalLink?: boolean
  className?: string
}

export const FooterLink = ({
  href,
  children,
  internalLink = false,
  className,
}: Props) => {
  const { language } = useI18next()

  if (internalLink) {
    return (
      <Link
        to={href}
        language={language}
        className={`${className ? className : ""} text-foreground-base cursor-pointer no-underline hover:text-ctaMain`}
      >
        <BodyTextRegular>{children}</BodyTextRegular>
      </Link>
    )
  }

  const opensInNewTab = !href.startsWith("mailto:") && !href.startsWith("tel:")

  return (
    <a
      href={href}
      target={opensInNewTab ? "_blank" : undefined}
      rel={opensInNewTab ? "noreferrer" : undefined}
      className={`${className ? className : ""} text-foreground-base cursor-pointer no-underline hover:text-ctaMain`}
    >
      <BodyTextRegular>{children}</BodyTextRegular>
    </a>
  )
}
